var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCompletedOrderCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F6EEED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8201 13.9099H19.1801C17.0601 13.9099 15.3201 15.6499 15.3201 17.7699V31.8599C15.3201 33.6599 16.6101 34.4199 18.1901 33.5499L23.0701 30.8399C23.5901 30.5499 24.4301 30.5499 24.9401 30.8399L29.8201 33.5499C31.4001 34.4299 32.6901 33.6699 32.6901 31.8599V17.7699C32.6801 15.6499 30.9501 13.9099 28.8201 13.9099ZM27.6201 21.0299L23.6201 25.0299C23.4701 25.1799 23.2801 25.2499 23.0901 25.2499C22.9001 25.2499 22.7101 25.1799 22.5601 25.0299L21.0601 23.5299C20.7701 23.2399 20.7701 22.7599 21.0601 22.4699C21.3501 22.1799 21.8301 22.1799 22.1201 22.4699L23.0901 23.4399L26.5601 19.9699C26.8501 19.6799 27.3301 19.6799 27.6201 19.9699C27.9101 20.2599 27.9101 20.7399 27.6201 21.0299Z",
    fill: "#8D5245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCompletedOrderCardIcon);
export default __webpack_public_path__ + "static/media/dashboard-completed-order-card-icon.8f7231dc0d6822d55519d03ff37272cd.svg";
export { ForwardRef as ReactComponent };